module.exports = __webpack_public_path__ + "media/about/julia-61268c58.jpg";